import { camelcaseKeys } from 'src/utils/camelize-keys';
import { centsToDollars } from 'src/utils/fieldNormalizers';

import { FranchiseFeeLineItem } from './_types';

export const normalizeFranchiseFeeLineItem = (
  data: any
): FranchiseFeeLineItem => {
  const camelized = camelcaseKeys(data, { deep: true });

  if (camelized.amount) {
    camelized.amount = centsToDollars(camelized.amount);
  }

  if (camelized.transactionAmount) {
    camelized.transactionAmount = centsToDollars(camelized.transactionAmount);
  }

  return camelized;
};
